// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"'styles/breakpoints.module.css'","TABLET_WIDTH":"768px","col":"styles_col__CHwZd","imageContainer":"styles_imageContainer__kIOJD"};